module.exports = __webpack_public_path__ + "i18n/translation-en.65d27b38.json";